import Vue from "vue";
import { RichTextEditorPlugin, Toolbar, Link, Image, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-vue-richtexteditor';
import moment from 'moment';
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import MenuRightSerivce from "@/service/MenuRightService";
import JobAdsService from "@/service/JobAdsService";
import UserService from "@/service/UserService";
import JobsService from "@/service/JobsService";
import StaffService from "@/service/StaffService"
import { JobAds } from "@/model/JobAds";
import { User } from "@/model/User";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import jobValidationObj from "./S090100-JobValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var jobAdValidationObj = new jobValidationObj();
Vue.use(RichTextEditorPlugin);
export default {
  components: {
    DatePicker, paginate: Paginate,
  },
  provide: {
    richtexteditor: [Toolbar, Link, Image, HtmlEditor, QuickToolbar]
  },
  data: () => ({
    dictEnum: dictEnum,
    jobAds: new JobAds(),
    tempJobAds: new JobAds(),
    selectJobAds: new JobAds(),
    tempIndex: "",
    tempUser: new User(),
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.Job,
    Settings: Settings,
    companyList: [],
    jobCodeList: [],
    userList: [],
    jobAdList: [],
    searchText: "",
    IsLoaded: true,
    jobAdObj: {
      selectAll: false
    },
    isCloseJob: false,
    isCompanyData: false,
    isUserData: false,
    isJobCodeData: false,
    isViewMode: true,
    IsEditMode: false,
    quickToolbarSettings: {
      image: [
        'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
        'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension',
      ],
      link: ['Open', 'Edit', 'UnLink']
    },
    toolbarSettings: {
      type: 'Expand',
      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
        'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
        'LowerCase', 'UpperCase', '|',
        'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
        'Outdent', 'Indent', '|',
        'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
        'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
    },
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: this.currentSelectedPage + 1,
    totalRecords: 0,
    richtextHeight: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    jobAdDataList() {
      return this.jobAdList;
    },
  },
  mounted() {
    jobAdValidationObj.jobAdValidation();
    this.init();
    this.assignRights();
    this.scrollContent();
    this.getAllJobAdsList();
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var closeHeight = $(".close-job").height();
      var tableHeaderHeight = $("table thead").height();
      var pagginationHeight = $(".paggination-job").height();
      var ckeditorHeight = $(".ckeditor-header").height();
      var ckeditorTopHeight = $(".e-toolbar-items").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var closeJobHeight = closeHeight != undefined ? closeHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - closeJobHeight - tHeadHeight - paggHeight;
      self.take = Number((tableHeight / 39).toFixed());
      var ckeditorHeaderHeight = ckeditorHeight != undefined && ckeditorHeight != 0 ? ckeditorHeight : 34;
      var ckeditorToolbarHeight = ckeditorTopHeight != undefined && ckeditorTopHeight != 0 ? ckeditorTopHeight : 44;
      self.richtextHeight = docHeight - headHeight - ckeditorHeaderHeight - ckeditorToolbarHeight - 50;
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    async getCompanyList() {
      var self = this;
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        self.companyList = response.data.Data;
        if (self.companyList != null && self.companyList.length > 0 && self.jobAdList.length > 0) {
          self.jobAdList.forEach(element => {
            var companyDetail = self.companyList.find((obj) => obj.CompCode == element.CompCode);
            if (companyDetail != null && companyDetail != undefined) {
              element.CompName = self.user.Lang == 'EN' ? companyDetail.EName : companyDetail.CName;
            }
          });
        }
        self.isCompanyData = true;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllUsers() {
      var self = this;
      const obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: false
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        self.userList = response.data.Data;
        if (self.userList != null && self.userList.length > 0 && self.jobAdList.length > 0) {
          self.jobAdList.forEach(element => {
            var userDetail = self.userList.find((obj) => obj.StaffID == element.Interviewer);
            if (userDetail != null && userDetail != undefined) {
              element.UserName = self.user.Lang == 'EN' ? userDetail.EngName : userDetail.ChiName;
            }
          });
          self.isUserData = true;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllJob() {
      var self = this;
      const obj = {};
      const response = await JobsService.getAllJobs(obj);
      if (response.data.IsSuccess) {
        self.jobCodeList = response.data.Data;
        if (self.jobCodeList != null && self.jobCodeList.length > 0 && self.jobAdList.length > 0) {
          self.jobAdList.forEach(element => {
            var jobCodeDetail = self.jobCodeList.find((obj) => obj.JobCode == element.JobCode);
            if (jobCodeDetail != null && jobCodeDetail != undefined) {
              element.JobPosition = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
            }
          });
          self.isJobCodeData = true;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllJobAdsList() {
      var self = this;
      self.isJobCodeData = false;
      self.isCompanyData = false;
      self.isUserData = false;
      const obj = {
        take: self.take,
        skip: self.skip,
        includeCloseJob: self.isCloseJob,
      };
      const response = await JobAdsService.getAllJobAdsList(obj);
      if (response.data.IsSuccess) {
        self.jobAdList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
        if (self.jobAdList != null && self.jobAdList.length > 0) {
          self.tempJobAds = self.jobAdList[0];
          self.tempIndex = 0;
          var tempCode = 1;
          self.jobAdList.forEach(
            (element, index) => {
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.IsNewAdded = false;
              tempCode++;
            }
          );
        }
        self.getCompanyList();
        self.getAllUsers();
        self.getAllJob();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnEditButtonClick: function () {
      var self = this;
      if (self.selectJobAds.JobAdCode != "") {
        self.IsLoaded = false;
        self.jobAdList.forEach(element => {
          if (element.tempCode == self.selectJobAds.tempCode) {
            self.IsLoaded = true;
            element.IsEditMode = true;
          } else {
            self.IsLoaded = true;
            element.IsEditMode = false;
          }
        });
        self.isViewMode = false;
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    OnAddJobAdButtonClick: function () {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          var tempCode = 1;
          var seq = 1;
          self.jobAdList.forEach((element, index) => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format("YYYY-MM-DD");
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format("YYYY-MM-DD");
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var jobAds = new JobAds();
          jobAds.Seq = seq;
          jobAds.tempCode = tempCode;
          jobAds.IsEditMode = true;
          jobAds.IsNewAdded = true;
          self.jobAdList.push(jobAds);
          self.tempIndex = self.jobAdList.length - 1;
        }
      });
      self.IsLoaded = true;
      self.isCompanyData = true
      self.isUserData = true;
      self.isJobCodeData = true;
      self.jobAdObj.selectAll = false;
      self.isViewMode = false;
      self.IsEditMode = false;
    },
    OnJobAdDeleteClick: function (data) {
      var self = this;
      self.jobAdList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.jobAdList.splice(index, 1);
          return;
        }
      });
      self.tempJobAds = self.jobAdList[0];
    },
    OnJobAdSelection: function (item, index) {
      var self = this;
      self.selectJobAds = item;
      self.IsEditMode = true;
      if (!self.hasRight('AlwWrite') || !self.hasRight('AlwChg')) {
        self.tempIndex = index;
        return;
      }
      if (self.isViewMode) {
        self.tempIndex = index;
        return;
      }
      if (item.IsEditMode) {
        self.tempIndex = index;
        return;
      }
      self.IsLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.tempIndex = index;
          self.jobAdList.forEach(element => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format("YYYY-MM-DD");
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format("YYYY-MM-DD");
            }
            if (element.tempCode == item.tempCode) {
              self.IsLoaded = true;
              element.IsEditMode = true;
              self.tempJobAds = element;
            } else {
              self.IsLoaded = true;
              element.IsEditMode = false;
            }
          });
        }
        self.IsLoaded = true;
      });
    },
    selectAllJobAdRecord: function () {
      var self = this;
      var IsSelected = self.jobAdObj.selectAll;
      self.jobAdList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleJobAdPopup: function () {
      var arrayList = [];
      var self = this;
      self.jobAdList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteJobAdModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleJobAd: function () {
      var self = this;
      var arrayList = [];
      var self = this;
      self.jobAdList.forEach(function (key, value) {
        if (key.isSelected && !key.IsNewAdded) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        arrayList.forEach(element => {
          if (element.DateFrom != null && element.DateFrom != "") {
            element.DateFrom = moment(String(element.DateFrom)).format("YYYY-MM-DD");
          }
          else {
            element.DateFrom = '1900-01-01';
          }
          if (element.DateTo != null && element.DateTo != "") {
            element.DateTo = moment(String(element.DateTo)).format("YYYY-MM-DD");
          }
          else {
            element.DateTo = '1900-01-01';
          }
          element.AddBy = self.$store.getters[StoreGetter.user].UserID;
          element.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
        });
        const obj = {
          jobAdsList: arrayList
        };
        $('#deleteJobAdModel').modal('hide');
        self.deleteJobAdData(obj);
      }
      else {
        var jobAdList = self.jobAdList.filter(
          obj => obj.IsNewAdded !== true
        );
        self.jobAdList = jobAdList;
        self.tempIndex = self.jobAdList.length - 1;
      }
    },
    closeJobAdPopup: function () {
      var self = this;
      $('#deleteJobAdModel').modal('hide');
    },
    OnUserBtnClick: function () {
      $("#userModel").modal("show");
    },
    OnUserSelect: function (model) {
      var self = this;
      self.tempUser = model;
    },
    OnUserModalSelectBtnClick: function () {
      var self = this;
      if (self.tempUser.StaffID != "" && self.tempUser.StaffID != undefined) {
        self.IsLoaded = false;
        self.jobAdList.forEach(element => {
          if (element.IsEditMode) {
            element.UserName = self.user.Lang == 'EN' ? self.tempUser.EngName : self.tempUser.ChiName;
            element.Interviewer = self.tempUser.StaffID;
            self.IsLoaded = true;
          }
        });
        const field = self.$validator.fields.find("Interviewer");
        field.reset();
        self.$validator.errors.remove("Interviewer", field.scope);
        $("#userModel").modal("hide");
        self.tempUser = new User();
        self.IsLoaded = true;
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.WARN_SelectUser));
      }
    },
    changeCompany: function (item) {
      var self = this;
      var companyDetail = self.companyList.find(
        obj => obj.CompCode == item.CompCode
      );
      item.CompName = self.user.Lang == 'EN' ? companyDetail.EName : companyDetail.CName;
    },
    changeJobPosition: function (item) {
      var self = this;
      var jobCodeDetail = self.jobCodeList.find(
        obj => obj.JobCode == item.JobCode
      );
      item.JobPosition = self.user.Lang == 'EN' ? jobCodeDetail.EDesc : jobCodeDetail.CDesc;
    },
    async saveJobAd() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          if (self.jobAdList.length > 0) {
            self.jobAdList.forEach(element => {
              if (element.DateFrom != null && element.DateFrom != "") {
                element.DateFrom = moment(String(element.DateFrom)).format("YYYY-MM-DD");
              }
              else {
                element.DateFrom = '1900-01-01';
              }
              if (element.DateTo != null && element.DateTo != "") {
                element.DateTo = moment(String(element.DateTo)).format("YYYY-MM-DD");
              }
              else {
                element.DateTo = '1900-01-01';
              }
              element.AddBy = self.$store.getters[StoreGetter.user].UserID;
              element.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
            });
          }
          const obj = {
            jobAdsList: self.jobAdList
          };
          self.saveJobAdData(obj);
        }
        else {
          SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_ValidationFailed));
        }
      })
        .catch(() => {
          SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_ValidationFailed));
        });
    },
    async saveJobAdData(obj) {
      var self = this;
      const response = await JobAdsService.saveJobAd(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetJobAdData();
        self.init();
        await self.getAllJobAdsList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async deleteJobAdData(obj) {
      var self = this;
      const response = await JobAdsService.deleteJobAds(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetJobAdData();
        self.init();
        self.tempJobAds = new JobAds();
        await self.getAllJobAdsList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    resetJobAdData() {
      var self = this;
      self.selectJobAds = new JobAds();
      self.isViewMode = true;
      self.IsEditMode = false;
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = self.currentSelectedPage + 1;
      self.totalRecords = 0;
    },
    cancelJobAdData() {
      var self = this;
      self.resetJobAdData();
      self.init();
      self.getAllJobAdsList();
    },
    selectCloseJobAd() {
      var self = this;
      self.init();
      self.getAllJobAdsList();
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.currentSelectedPage = pagenumber - 1;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) - 1;
      if (this.skip != 0) {
        this.skip++;
      }
      this.getAllJobAdsList();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090100-Job/S090100-Job.js